import {
  Drawer,
  DrawerContent,
  DrawerItem
} from '@progress/kendo-react-layout';
import * as c from 'constants/routes';
import routes from 'jsons/connected-routes.json';
import PropTypes from 'prop-types';
import * as React from 'react';
import { Header } from './Header.jsx';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../redux/store.js';
import { logout } from '../../redux/slices/appStateSlice.js';

export default function DrawerRouterContainer(props) {
  const [selectedItem, setSelectedItem] = React.useState(undefined);
  const [isSmallerScreen, setIsSmallerScreen] = React.useState(
    window.innerWidth < c.MIN_WIDTH
  );
  const navigate = useNavigate();
  const location = useLocation();
  const user = useAppSelector(state => state.appState.user);
  const token = useAppSelector(state => state.appState.token);
  const dispatch = useDispatch();

  const CustomDrawerItem = (props) => {
    const arrowDir = props.expanded
      ? 'k-i-arrow-chevron-down'
      : 'k-i-arrow-chevron-right';
    const { ...other } = props;
    return (
      props.hidden === undefined && (
        <React.Fragment key={props.name + '-Fragment'}>
          <DrawerItem
            selected={selectedItem?.name === props.name}
            {...other}
            key={props.name}
          >
            <div style={{ display: 'grid', gridTemplateColumns: '15% 75% 10%', width: '100%' }}>
              <span
                style={{
                  backgroundColor: 'transparent',
                  width: props.name === 'Publicite' ? '0px' : '',
                  color: props.ext ? 'grey' : '',
                }}
                className={'k-icon k-font-icon ' + props.icon}
              ></span>
              <span
                className="k-item-text"
                style={{
                  fontWeight: props.name === 'Publicite' ? 'bold' : 'normal',
                  color: props.ext ? 'grey' : '',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                {props.debExt ? user : props.name}
              </span>
              {props.expanded !== undefined && (
                <span
                  className={'k-icon k-font-icon ' + arrowDir}
                  style={{
                    backgroundColor: 'transparent'
                  }}
                />
              )}
            </div>
          </DrawerItem>

          {props.expanded !== undefined &&
            props.expanded &&
            props.subs !== undefined &&
            CustomDrawerItemChildren(props)}
        </React.Fragment>
      )
    );
  };

  const CustomDrawerItemChildren = (props, allChilds = []) => {
    props.subs.forEach((prop) => {
      const arrowDir = prop.expanded
        ? 'k-i-arrow-chevron-down'
        : 'k-i-arrow-chevron-right';
      allChilds.push(
        prop.hidden === undefined && (
          <React.Fragment key={prop.name + '-Fragment'}>
            <DrawerItem
              selected={selectedItem?.name === prop.name}
              onSelect={(e) => {
                e.itemTarget = {};
                e.itemTarget.props = prop;
                handleSelect(e);
              }}
              key={prop.name}
            >
              <div style={{
                display: 'flex',
                alignItems: 'center'
              }}>
                <span
                  style={{
                    color:
                      selectedItem?.name === prop.name ? '#2980b9' : 'inherit',
                    marginRight: '10px',
                    backgroundColor: 'transparent',
                    marginLeft: '15px',
                  }}
                  className={'k-icon k-font-icon ' + prop.icon}
                ></span>
                <span className="k-item-text">{prop.name}</span>
              </div>

              {prop.expanded !== undefined && (
                <span
                  className={'k-icon k-font-icon ' + arrowDir}
                  style={{
                    position: 'absolute',
                    backgroundColor: 'transparent',
                    right: 10,
                  }}
                />
              )}
            </DrawerItem>
            {prop.expanded !== undefined &&
              prop.expanded &&
              prop.subs !== undefined &&
              CustomDrawerItemChildren(prop)}
          </React.Fragment>
        )
      );
    });

    return allChilds;
  };

  const getSubMenuItem = React.useCallback((subMenuItems, id) => {
    if (id !== undefined && subMenuItems) {
      for (var i = 0; i < subMenuItems.length; i++) {
        if (subMenuItems[i].id === id) {
          return subMenuItems[i];
        }
        var found = getSubMenuItem(subMenuItems[i].subs, id);
        if (found) return found;
      }
    }
  }, []);

  const setExpandedSelectedItem = React.useCallback(
    (pathName) => {
      let item = getSubMenuItem(routes, pathName);
      if (!item?.parent) {
        let allPaths = pathName.split('/');
        let addedPath = '';
        allPaths.forEach((path) => {
          if (path !== '') addedPath += `/${path}`;
          let item = getSubMenuItem(routes, addedPath);
          if (item?.parent) {
            item.expanded = true;
          }
        });
      }
      if (item?.parent) {
        item.expanded = true;
      }
      setSelectedItem({ ...item });
    },
    [getSubMenuItem]
  );

  React.useEffect(() => {
    setExpandedSelectedItem(location.pathname);
    window.addEventListener('resize', () => {
      setIsSmallerScreen(window.innerWidth < c.MIN_WIDTH);
    });
    return () =>
      window.removeEventListener('resize', () => {
        setIsSmallerScreen(window.innerWidth < c.MIN_WIDTH);
      });
  }, [location.pathname, props.onEvent, setExpandedSelectedItem]);

  const handleSelect = (e) => {
    if (e.itemTarget.props.type === 'logout') {
      dispatch(logout());
    }

    if (e.itemTarget.props.type === 'planogramme') {
      window.open(`${process.env.REACT_APP_PLANO_URL}?token=${token.split(' ')[1]}&user=${user}`, "_blank");
    }

    if (e.itemTarget.props.type === 'approbationWeb') {
      window.open(`${process.env.REACT_APP_APPROBATIONWEB_URL}`, "_blank");
    }

    let item = getSubMenuItem(routes, e.itemTarget.props.id);

    if (item !== undefined && item.parent) {
      item.expanded = !item.expanded;
    }
    if (item !== undefined) {
      setSelectedItem({ ...item });
    }

    if (e.itemTarget.props.route)
      navigate(e.itemTarget.props.route);
  };

  return (
    <React.Fragment>
      <Header />
      <Drawer
        width={225}
        expanded={true}
        items={routes}
        item={CustomDrawerItem}
        position="start"
        mode={isSmallerScreen ? 'overlay' : 'push'}
        mini={isSmallerScreen ? false : true}
        onSelect={handleSelect}
      >
        <DrawerContent>{props.children}</DrawerContent>
      </Drawer>
    </React.Fragment>
  );
}

DrawerRouterContainer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  expanded: PropTypes.bool,
  hidden: PropTypes.bool,
  icon: PropTypes.string,
  name: PropTypes.string,
  onEvent: PropTypes.func,
  parent: PropTypes.bool,
  subs: PropTypes.array,
  skip: PropTypes.bool,
  ext: PropTypes.bool,
  debExt: PropTypes.bool,
};
